import { connect } from 'react-redux';
import { getActiveStreamType } from '../redux/selectors';
import { switchStream } from '../redux/actionCreators';
import { EmoteStreamType } from '../redux/types';
const mapStateToProps = (state)=>({
        activeStream: getActiveStreamType(state) || EmoteStreamType.OFFICIAL
    });
const mapDispatchToProps = {
    switchStream: switchStream
};
export default connect(mapStateToProps, mapDispatchToProps);

//# sourceMappingURL=TabsHeader.container.js.map